/**
 * Workspace-scoped Basecamp routes: /basecamp/{workspaceId}/... vs legacy /basecamp/...
 */

/** First path segment after /basecamp that is never a workspace/org id. */
export const BASECAMP_SEGMENT_LITERALS = new Set([
  'bookmarks',
  'mystuff',
  'todos',
  'projects',
  'project',
  'triage',
  'todo',
])

/** Prefix for tab -> URL; omit workspace when unknown (legacy URLs). */
export function basecampRoutePrefix(
  workspaceIdOrSlug?: string | null,
  workspaceSlug?: string | null
): string {
  const slug = workspaceSlug ?? workspaceIdOrSlug
  if (slug) {
    return `/${encodeURIComponent(slug)}/basecamp`
  }
  return '/basecamp'
}

/**
 * If pathname is /basecamp/{orgId}/..., return orgId and pathname rewritten to /basecamp/...
 * Legacy URLs (no org segment) leave pathname unchanged.
 */
export function stripOptionalBasecampWorkspaceSegment(pathname: string): {
  workspaceId?: string
  strippedPath: string
} {
  if (!pathname.startsWith('/basecamp')) {
    return { strippedPath: pathname }
  }
  const rest = pathname.slice('/basecamp'.length)
  if (rest === '' || rest === '/') {
    return { strippedPath: pathname }
  }
  const parts = rest.replace(/^\//, '').split('/').filter(Boolean)
  const first = parts[0] ?? ''
  if (!first || BASECAMP_SEGMENT_LITERALS.has(first)) {
    return { strippedPath: pathname }
  }
  const workspaceId = decodeURIComponent(first)
  const tail = parts.slice(1).join('/')
  const strippedPath = tail ? `/basecamp/${tail}` : '/basecamp'
  return { workspaceId, strippedPath }
}

/** Matches /basecamp/project/:pid/todo/:tid OR /basecamp/:workspaceId/project/:pid/todo/:tid */
export const BASECAMP_PROJECT_TODO_IN_PATH_RE =
  /^\/basecamp(?:\/[^/]+)?\/project\/(\d+)\/todo\/(\d+)/
